import React from "react"
import MainLayout from "./ui/layout/MainLayout"

export default () => <MainLayout />



// WEBPACK FOOTER //
// ./src/App.js